import { render, staticRenderFns } from "./FeHersot.vue?vue&type=template&id=4bd66165&"
import script from "./FeHersot.vue?vue&type=script&lang=js&"
export * from "./FeHersot.vue?vue&type=script&lang=js&"
import style0 from "./FeHersot.vue?vue&type=style&index=0&id=4bd66165&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports